import {Component, inject, OnDestroy, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogModule, MatDialogRef} from "@angular/material/dialog";
import {CommonModule, DatePipe} from '@angular/common';
import {MatDividerModule} from '@angular/material/divider';
import {MatIconModule} from '@angular/material/icon';
import {Subject, takeUntil} from 'rxjs';
import {IncentiveService} from "../../../../../../shared/services/incentive.service";
import {IIncentiveHistory} from "../../../../../../utils/interfaces/incentive";
import {LoadingService} from "../../../../../../shared/services/loading.service";

@Component({
  selector: 'app-unit-incentive-history.dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatDividerModule,
    MatIconModule,
    DatePipe
  ],
  templateUrl: './unit-incentive-history.dialog.component.html',
  styleUrl: './unit-incentive-history.dialog.component.scss'
})
export class UnitIncentiveHistoryDialogComponent implements OnInit, OnDestroy {
  readonly dialogRef = inject(MatDialogRef<UnitIncentiveHistoryDialogComponent>);
  readonly data = inject<{ unitId: string }>(MAT_DIALOG_DATA);

  private readonly incentiveService = inject(IncentiveService);
  private readonly loadingService = inject(LoadingService);
  private readonly unsubscribe$ = new Subject<void>();

  incentiveHistory: IIncentiveHistory[] = [];
  isLoading = false;

  ngOnInit(): void {
    if (this.data?.unitId) {
      this.loadIncentiveHistory();
    } else {
      console.error('Unit ID is missing');
      this.dialogRef.close();
    }
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  private loadIncentiveHistory(): void {
    this.isLoading = true;
    this.loadingService.showLoading();

    this.incentiveService.getHistoryPerBranchId(this.data.unitId)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe({
        next: (response) => {
          if (response.success) {
            this.incentiveHistory = response.data || [];
          } else {
            console.error('Failed to load incentive history:', response.message);
          }
          this.isLoading = false;
          this.loadingService.closeLoading();
        },
        error: (error) => {
          console.error('Error loading incentive history:', error);
          this.isLoading = false;
          this.loadingService.closeLoading();
        }
      });
  }
}
